// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2fNJE","dragIcon":"Choice_dragIcon__39aVU","left":"Choice_left__3QiI1","input":"Choice_input__2RGoW"};